import { render, staticRenderFns } from "./driverReview.vue?vue&type=template&id=9448101e&scoped=true"
import script from "./driverReview.vue?vue&type=script&lang=js"
export * from "./driverReview.vue?vue&type=script&lang=js"
import style0 from "./driverReview.vue?vue&type=style&index=0&id=9448101e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9448101e",
  null
  
)

export default component.exports